module.exports = __webpack_public_path__ + "img/bg16.09937edd.png";